module.exports = __webpack_public_path__ + "static/media/olaglig.17db10e3.mp3";